"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchSummary } from "@repo/design-system/hooks/use-search-summary";
import { useRegistry } from "~/components/registry/registry-provider";
import { useLanguage } from "~/translations/loader/use-language";
import { OptionBadge } from "./filters/option-badge-eon";
export function SearchSummary() {
  const $ = _c(11);
  const t = useLanguage();
  const {
    ui
  } = useRegistry();
  const {
    options
  } = useSearchSummary();
  const emptyLabel = ui?.searchSummaryEmpty ?? t.searchSummary_worldwide;
  let t0;
  if ($[0] !== emptyLabel || $[1] !== options.length) {
    t0 = !options.length && <span className="font-medium">{emptyLabel}</span>;
    $[0] = emptyLabel;
    $[1] = options.length;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t.searchSummary_main || $[4] !== t0) {
    t1 = <p className="mr-2 whitespace-nowrap text-foreground text-lg">{t.searchSummary_main}{": "}{t0}</p>;
    $[3] = t.searchSummary_main;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options) {
    t2 = options.length > 0 && <div className="inline-block w-full"><div className="flex flex-wrap items-center gap-2">{options.map(_temp)}</div></div>;
    $[6] = options;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <section className="flex min-h-[80px] w-full justify-center bg-card text-foreground text-lg"><div className="mx-6 flex w-full max-w-screen-xl items-center justify-between md:mx-10" id="search-summary-bar"><div className="w-full items-center py-2 md:flex">{t1}{t2}</div></div></section>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp(option) {
  return <OptionBadge capped={false} key={option.value} onValueRemove={option.onRemove} option={option} variant="outline" />;
}